import { motion } from 'framer-motion'
import { ArrowRight, Mail, MessageSquare } from 'lucide-react'
import { Link } from 'react-router-dom'

export const CTA = () => {
    return (
        <section className="py-24 relative overflow-hidden">
            {/* Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-primary-900/20 via-secondary-900/20 to-accent-900/20" />
            <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-primary-500/10 via-transparent to-transparent" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                    className="text-center"
                >
                    {/* Main Content */}
                    <h2 className="text-4xl md:text-6xl font-bold mb-6">
                        Ready to Transform Your
                        <br />
                        <span className="gradient-text">AI Journey?</span>
                    </h2>
                    <p className="text-xl text-slate-400 mb-12 max-w-3xl mx-auto">
                        Let AgentForge AI help your enterprise maximize AI value.
                        Start scaling your LLM agents from prototype to production today.
                    </p>

                    {/* Action Buttons */}
                    <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-16">
                        <Link
                            to="/contact"
                            className="group px-8 py-4 bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-500 hover:to-secondary-500 rounded-xl font-semibold text-lg transition-all duration-300 shadow-lg shadow-primary-500/25 hover:shadow-primary-500/40 flex items-center space-x-2"
                        >
                            <MessageSquare className="w-5 h-5" />
                            <span>Schedule a Demo</span>
                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </Link>
                        <a
                            href="mailto:contact@agentforge.ai"
                            className="group px-8 py-4 bg-slate-800/50 hover:bg-slate-700/50 border border-slate-700 hover:border-slate-600 rounded-xl font-semibold text-lg transition-all duration-300 flex items-center space-x-2"
                        >
                            <Mail className="w-5 h-5" />
                            <span>Contact Sales</span>
                        </a>
                    </div>

                    {/* Contact Information */}
                    <div className="grid md:grid-cols-2 gap-8 max-w-2xl mx-auto">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.1 }}
                            className="p-6 rounded-xl bg-slate-800/30 border border-slate-700/50 backdrop-blur-sm"
                        >
                            <Mail className="w-8 h-8 text-primary-400 mb-3 mx-auto" />
                            <h3 className="text-lg font-semibold mb-2">Email Us</h3>
                            <a
                                href="mailto:contact@agentforge.ai"
                                className="text-slate-400 hover:text-primary-400 transition-colors"
                            >
                                contact@agentforge.ai
                            </a>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            className="p-6 rounded-xl bg-slate-800/30 border border-slate-700/50 backdrop-blur-sm"
                        >
                            <MessageSquare className="w-8 h-8 text-primary-400 mb-3 mx-auto" />
                            <h3 className="text-lg font-semibold mb-2">Live Chat</h3>
                            <p className="text-slate-400">Available 24/7 for support</p>
                        </motion.div>
                    </div>
                </motion.div>
            </div>
        </section>
    )
}

